import Api from "../../../../core/services/api/api";
import type {CancelToken} from "axios";
import type {PartFormQualificationDs} from "../../../../core/services/api/type-declerations/response";
import {
    parsePartFormQualificationApiError,
    type PartFormQualificationErrorInfo,
} from "./parse-part-form-qualification-error";

export interface PartFormQualificationFetchResult {
    qualification: PartFormQualificationDs | null;
    error: boolean;
    aborted: boolean;
    errorInfo: PartFormQualificationErrorInfo | null;
}

/**
 * Fetches the part form qualification for the given part and customer.
 */
export async function fetchPartFormQualification(
    partId: number | string,
    customerId: number | string,
    cancelToken?: CancelToken,
): Promise<PartFormQualificationFetchResult> {
    const response = await Api.checkFormQualificationForPart(partId, customerId, cancelToken, false);
    if (response?.aborted) {
        return {qualification: null, error: false, aborted: true, errorInfo: null};
    }
    if (response?.resultFlag && response.data) {
        return {qualification: response.data, error: false, aborted: false, errorInfo: null};
    }
    return {
        qualification: null,
        error: true,
        aborted: false,
        errorInfo: parsePartFormQualificationApiError(response),
    };
}
